import React from 'react';
import { motion } from 'framer-motion';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = '9779844511713';
  const message = 'Hi Suraj Kumar Sah! I visited your portfolio website and would like to connect with you.';

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1, duration: 0.5 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <div className="whatsapp-icon">
        💬
      </div>
      <div className="whatsapp-tooltip">
        Chat on WhatsApp
      </div>
    </motion.a>
  );
};

export default WhatsAppButton;